(function () {
    Titania = typeof (Titania) != "undefined" && Titania || {};
    Titania.Enums = Titania.Enums || {};

    Titania.Enums._AddReverseLookup = function (enumeration) {
        if (enumeration.hasOwnProperty("properties")) {
            delete enumeration.properties;
        }

        var props = {};
        for (var k in enumeration) {
            props[enumeration[k]] = k;
        }

        enumeration.properties = props;
    }
})();